import React from "react";
import MasterdataIndexlinks from "./indexLinks";
import axios from "axios";
import Select from "react-select";
import FormErrorHandler from "../../components/FormErrorHandler";
import { scrollToElem } from "../../functions.js";
import debounce from "debounce-promise";

export default class masterdataEndtermsForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            editMode: props.params.itemID !== undefined,
            errorMessage: {},
            collections: [],
            name: "",
            abbreviation: "",
            order: 1,
            description: "",
            threshold_percentage: "",
            authorities: [],
            collection: "Overig",
            is_active: 0
        };
    }

    updateElementState = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    loadOptions = (url) => {
        return axios.get(url).then((response) => {
            return {
                options: response.data.map((item) => {
                    return {
                        value: item.code,
                        label: item.name
                    };
                })
            };
        });
    };

    loadAuthoritiesDebounced = debounce(this.loadOptions, 500);

    handleOptionsChange = (val, stateName) => {
        if (Array.isArray(val)) {
            this.setState({
                [stateName]: val.map((option) => {
                    return option.value;
                })
            });
        } else {
            this.setState({
                [stateName]: val.value
            });
        }
    };

    handleSubmit = (e) => {
        e.preventDefault();

        let postData = {
            name: this.state.name,
            abbreviation: this.state.abbreviation,
            description: this.state.description,
            authorities: this.state.authorities,
            collection: this.state.collection,
            order: this.state.order,
            threshold_percentage: this.state.threshold_percentage,
            is_active: this.state.is_active,
            can_be_exempted: this.state.can_be_exempted
        };

        if (this.state.editMode) {
            axios
                .patch("/v1/end_terms/" + this.props.params.itemID + "/", postData)
                .then((response) => {
                    this.props.addGlobalMessage({
                        title: `De eindterm '${this.state.name}' is succesvol opgeslagen`,
                        link: `/masterdata/endterms/edit/${this.props.params.itemID}`
                    });
                    this.props.router.push("/masterdata/endterms");
                })
                .catch((error) => {
                    this.setState({
                        errorMessage: error.response.data
                    });
                    scrollToElem(document.querySelector(".form-error"));
                });
        } else {
            axios
                .post("/v1/end_terms/", postData)
                .then((response) => {
                    this.props.addGlobalMessage({
                        title: `De eindterm '${this.state.name}' is succesvol opgeslagen`,
                        link: `/masterdata/endterms/edit/${response.data.uuid}`
                    });
                    this.props.router.push("/masterdata/endterms");
                })
                .catch((error) => {
                    this.setState({
                        errorMessage: error.response.data
                    });
                    scrollToElem(document.querySelector(".form-error"));
                });
        }
    };

    componentDidMount() {
        if (this.state.editMode) {
            axios
                .get("/v1/end_terms/" + this.props.params.itemID + "/")
                .then((response) => {
                    this.setState({
                        name: response.data.name,
                        abbreviation: response.data.abbreviation,
                        description: response.data.description,
                        authorities: response.data.authorities,
                        collection: response.data.collection,
                        threshold_percentage: response.data.threshold_percentage,
                        order: response.data.order,
                        is_active: response.data.is_active ? 1 : 0,
                        can_be_exempted: response.data.can_be_exempted ? 1 : 0
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        }
        axios.get("/v1/collections/").then((response) => {
            this.setState({
                collections: response.data.results
            });
        });
    }

    render() {
        let collectionValues = [];
        this.state.collections.forEach((coll) => {
            collectionValues.push(
                <option key={`collection-${coll.name}`} value={coll.name}>
                    {coll.name}
                </option>
            );
        });

        return (
            <div>
                <MasterdataIndexlinks />

                <div>
                    <h2>Eindterm {this.state.editMode ? "bewerken" : "toevoegen"}</h2>

                    <form onSubmit={this.handleSubmit} ref="formref">
                        <div className="row">
                            <div className="col-6">
                                <div className="form-group">
                                    <label>Titel *</label>
                                    <input
                                        tabIndex="1"
                                        type="text"
                                        name="name"
                                        ref="name"
                                        autoFocus={true}
                                        onChange={this.updateElementState}
                                        className="form-control form-control-md"
                                        required={true}
                                        value={this.state.name}
                                    />
                                    <FormErrorHandler fieldName="name" errorObject={this.state.errorMessage} />
                                </div>
                                <div className="form-group">
                                    <label>Afkorting *</label>
                                    <input
                                        tabIndex="2"
                                        type="text"
                                        name="abbreviation"
                                        ref="abbreviation"
                                        onChange={this.updateElementState}
                                        className="form-control form-control-md"
                                        required={true}
                                        value={this.state.abbreviation}
                                    />
                                    <FormErrorHandler fieldName="abbreviation" errorObject={this.state.errorMessage} />
                                </div>
                                <div className="form-group">
                                    <label>Omschrijving *</label>
                                    <textarea
                                        tabIndex="3"
                                        name="description"
                                        ref="description"
                                        onChange={this.updateElementState}
                                        className="form-control"
                                        required={true}
                                        value={this.state.description}
                                    ></textarea>
                                    <FormErrorHandler fieldName="description" errorObject={this.state.errorMessage} />
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <div className="form-group">
                                            <label>Collectie</label>
                                            <select
                                                tabIndex="4"
                                                className="form-control form-control-md"
                                                name="collection"
                                                ref="collection"
                                                onChange={this.updateElementState}
                                                value={this.state.collection == null ? "" : this.state.collection}
                                            >
                                                {collectionValues}
                                            </select>
                                            <FormErrorHandler fieldName="collection" errorObject={this.state.errorMessage} />
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="form-group">
                                            <label>Actief</label>
                                            <select
                                                tabIndex="5"
                                                className="form-control form-control-md"
                                                name="is_active"
                                                ref="is_active"
                                                onChange={this.updateElementState}
                                                value={this.state.is_active}
                                            >
                                                <option value="1">Ja</option>
                                                <option value="0">Nee</option>
                                            </select>
                                            <FormErrorHandler fieldName="is_active" errorObject={this.state.errorMessage} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <div className="form-group">
                                            <label>Vrijstellingen toestaan</label>
                                            <select
                                                tabIndex="6"
                                                className="form-control form-control-md"
                                                name="can_be_exempted"
                                                ref="can_be_exempted"
                                                onChange={this.updateElementState}
                                                value={this.state.can_be_exempted}
                                            >
                                                <option value="1">Ja</option>
                                                <option value="0">Nee</option>
                                            </select>
                                            <FormErrorHandler fieldName="can_be_exempted" errorObject={this.state.errorMessage} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="form-group">
                                    <label>Vereiste bevoegdheden</label>
                                    <Select.Async
                                        {...window.selectDefaults}
                                        name="authorities"
                                        tabIndex="7"
                                        value={this.state.authorities}
                                        loadOptions={() => this.loadAuthoritiesDebounced("/v1/authorities/?fields=code,name&pagination=false")}
                                        onChange={(val) => this.handleOptionsChange(val, "authorities")}
                                        multi={true}
                                    />
                                    <FormErrorHandler fieldName="authorities" errorObject={this.state.errorMessage} />
                                </div>
                                <div className="form-group">
                                    <label>Drempelpercentage *</label>
                                    <input
                                        tabIndex="8"
                                        type="number"
                                        name="threshold_percentage"
                                        ref="threshold_percentage"
                                        onChange={this.updateElementState}
                                        className="form-control form-control-md"
                                        required={true}
                                        value={this.state.threshold_percentage}
                                    />
                                    <FormErrorHandler fieldName="threshold_percentage" errorObject={this.state.errorMessage} />
                                </div>
                                <div className="form-group">
                                    <label>Volgorde *</label>
                                    <input
                                        tabIndex="9"
                                        type="number"
                                        name="order"
                                        ref="order"
                                        onChange={this.updateElementState}
                                        className="form-control form-control-md"
                                        required={true}
                                        value={this.state.order}
                                    />
                                    <FormErrorHandler fieldName="order" errorObject={this.state.errorMessage} />
                                </div>
                            </div>
                        </div>

                        <FormErrorHandler fieldName="non_field_errors" errorObject={this.state.errorMessage} />

                        <div className="form-group">
                            <button className="btn btn-primary" type="submit" tabIndex="50">
                                Opslaan
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}
